var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getSubscribersForQueryId } from "../getSubscribersForQueryId";
export function buildMessageHandler(store) {
    return function messageHandler(msgPromise) {
        return __awaiter(this, void 0, void 0, function* () {
            const msg = yield msgPromise;
            return getSubscribersForQueryId(store, msg.id).map(connection => {
                if (typeof msg.error !== "undefined" && typeof connection.onError === "function") {
                    connection.onError(msg.error);
                }
                else if (typeof msg.result !== "undefined") {
                    connection.onData(msg.result);
                }
                return connection;
            });
        });
    };
}
//# sourceMappingURL=buildMessageHandler.js.map